import { Mesh } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoaderSingleton } from "./DRACOLoaderSingleton";
import { KTX2LoaderSingleton } from "./KTX2LoaderSingleton";
import { Loader } from "./Loader";

let sharedGltfLoader: GLTFLoader | undefined;

export function getGLTFLoader() {
  if (!sharedGltfLoader) {
    sharedGltfLoader = new GLTFLoader();
    sharedGltfLoader.setDRACOLoader(DRACOLoaderSingleton.getInstance());
    sharedGltfLoader.setKTX2Loader(KTX2LoaderSingleton.getInstance());
  }
  return sharedGltfLoader;
}

export class Sugar3DLoader implements Loader {
  public constructor() {
    this._loader = getGLTFLoader();
  }

  private _loader: GLTFLoader;

  load(
    url: string,
    options?: { onProgress?: (event: ProgressEvent) => void } | undefined
  ) {
    return new Promise((resolve, reject) => {
      this._loader.load(
        url,
        (returnObject) => {
          returnObject.scene.traverse((mesh) => {
            if (mesh instanceof Mesh) {
              this.resolveShadow(mesh);
            }
          });
          resolve(returnObject.scene);
        },
        options?.onProgress,
        reject
      );
    });
  }

  private resolveShadow(mesh: Mesh) {
    mesh.castShadow = true;
    mesh.receiveShadow = false;
  }
}
